import React from "react";
import {Paper, IconButton, InputBase, CircularProgress} from "@mui/material";
import KeyboardIcon from "../../../../assets/icons/keyboardIcon";
import AddIcon from "../../../../assets/icons/addIcon";
import CameraIcon from "../../../../assets/icons/cameraIcon";
import SendIcon from "../../../../assets/icons/sendIcon";
import {SignalRContext} from "@config/signalR.ts";
import {
    addMessageToTop,
    Comment,
    createTicket,
    resetTicketCreateId,
    uploadAttachments
} from "@store/chatSlice.tsx";
import {useNavigate, useParams} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch} from "@store/store.tsx";
import dayjs from "dayjs";
import {fetchTicketDetailsById} from "@store/ticketListSlice";

interface ChatHeaderProps {
    isDrawerOpen: boolean;
    setIsDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
    customStatus: string,
}

const InputField: React.FC<ChatHeaderProps> = ({
                                                   isDrawerOpen,
                                                   setIsDrawerOpen,
                                                   customStatus
                                               }) => {
    const {id} = useParams();
    const inputRef = React.useRef()
    const [value, setValue] = React.useState("");
    const dispatch = useDispatch<AppDispatch>();
    const {user} = useSelector((state: any) => state.user);
    const attachments = useSelector((state: any) => state.chat.attachments);
    const {uploadStatus, ticketCreate} = useSelector((state: any) => state.chat)
    const [loading, setLoading] = React.useState(false)
    const navigate = useNavigate();
    const {messages} = useSelector(
        (state: any) => state.chat.chat
    );
    const disabledInput = id === 'new' && messages.length <= 3
    const onSend = () => {
        setLoading(true)
        const payload = {
            "type": "comment",
            "body": value,
            "public": true,
            "zendeskuserid": user.zendeskuserid,
            "attachments": [],
            "username": user.firstName + " " + user.lastName

        }
        setValue('')
        setTimeout(() => {
            setLoading(false)
        })
        SignalRContext.invoke("SendMessageToGroup", id?.toString(), payload)
        setTimeout(() => {
            if (id && id !== "new" && customStatus === "Resolved") {
                dispatch(fetchTicketDetailsById({id}));
            }
        }, 1000)
    }
    React.useEffect(() => {
        if (ticketCreate.id) {
            navigate(`/chat/${ticketCreate.id}`, {replace: true})
            dispatch(resetTicketCreateId())
        }
    }, [ticketCreate.id])

    const handleSendMessage = () => {
        if (id === 'new') {
            const comment: Comment = {
                id: 5,
                createdAt: dayjs().format(),
                attachments: [],
                type: 'comment',
                userName: null,
                body: value,
                public: true,
                autherId: user.zendeskUserId
            }
            setValue('')
            dispatch(addMessageToTop(comment));
            setTimeout(() => {
                dispatch(createTicket())
            });
        } else if (id) {
            if (attachments.length)
                dispatch(uploadAttachments({ticketId: id, text: value, inputRef: inputRef}));
            else
                onSend()
        }
    };

    const handleCameraCapture = (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if (files) {
            // dispatch(setAttachments([...attachments, ...newAttachments]));
            console.log("Captured Image/Video:", files[0]);
        }
    };

    return (
        <Paper
            sx={{
                display: "flex",
                alignItems: "center",
                borderRadius: 0,
                p: "1px",
                position: "sticky",
                bottom: 0,
                backgroundColor: "#fff",
            }}
            className={isDrawerOpen ? "!shadow-none" : "!shadow"}
        >
            {isDrawerOpen ? (
                <IconButton onClick={() => setIsDrawerOpen(false)}>
                    <KeyboardIcon/>
                </IconButton>
            ) : (
                <IconButton aria-label="open-drawer" onClick={() => setIsDrawerOpen(true)} disabled={id === 'new'}>
                    <AddIcon/>
                </IconButton>
            )}

            <InputBase
                ref={inputRef}
                inputComponent="textarea"
                multiline
                maxRows={6}
                minRows={1}
                disabled={loading || uploadStatus === 'loading' || ticketCreate.loading || disabledInput}
                placeholder="Type your query"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                sx={{
                    flex: 1,
                    ml: 1,
                    fontSize: "16px",
                    overflowY: "auto",
                    "& textarea": {
                        alignContent: "center",
                    },
                    "& textarea::-webkit-scrollbar": {
                        width: "2px",
                    },
                    "& textarea::-webkit-scrollbar-track": {
                        backgroundColor: "#f1f1f1",
                    },

                    "& textarea::-webkit-scrollbar-thumb": {
                        backgroundColor: "#C0C0C0",
                    },
                    "& textarea::-webkit-scrollbar-thumb:hover": {
                        backgroundColor: "gray",
                    },
                }}
            />
            <IconButton component="label" className="md:!hidden" hidden={id == 'new'}>
                <CameraIcon/>
                <input
                    type="file"
                    accept="image/*,video/*"
                    capture="environment"
                    hidden
                    onChange={handleCameraCapture}
                />
            </IconButton>
            <IconButton aria-label="send-message" onClick={handleSendMessage} disabled={loading || uploadStatus === 'loading' || disabledInput}>
                {
                    ticketCreate.loading || loading || uploadStatus === 'loading' ? <CircularProgress size={16}/> :
                        <SendIcon/>
                }

            </IconButton>
        </Paper>
    );
};

export default InputField;
